

//引入
import request from "../utils/request";
import wyqyId from "../config";
const api = {
    //组织人员列表
    zzrylist: function (params) {
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwybzhjs/zzrylist",
        });
    },

    //社会组织
    shzzlist: function (params) {
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwybzhjs/shzzlist",
        });
    },
    //社会组织人员
    shzzrylist: function (params) {
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwybzhjs/shzzrylist",
        });
    },
    //评价监督
    pjjdlist: function (params) {
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwybzhjs/pjjdlist",
        });
    },
    //-制度建设
    bzhjszdjslist: function (params) {
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwybzhjs/bzhjszdjslist",
        });
    },
    //--制度建设详情
    bzhjszdjsinfo: function (params) {
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwybzhjs/bzhjszdjsinfo",
        });
    },

    //-业主服务列表
    bzhjsyzfwlist: function (params) {
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwybzhjs/bzhjsyzfwlist",
        });
    },
    //--评优评先
    bzhjspypx: function () {
        let params = {
            wyqyId: wyqyId,
        }
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwybzhjs/bzhjspypx",
        });
    },

    // 社会组织查询
    shzzlist: function () {
        let params = {
            wyqyId: wyqyId,
        }
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwybzhjs/shzzlist",
        });
    },

    //业主服务列表
    bzhjsyzfwlist: function (params) {

        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwybzhjs/bzhjsyzfwlist",
        });
    },

    wygk: function () {
        let params = {
          wyqyId: wyqyId
        }
        return request({
          method: "get",
          params,
          url: `middlescreen/api/zhwyxyxx/wygk`,
        });
      },

}

export default api;